import styled from 'styled-components'
import { themeMedia } from '../../../styles/theme'

export const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 3em;

  ${themeMedia.maxTablet`
    height: ${({ navbarHeight = 0 }) => `calc(100vh - ${navbarHeight}px)`};
    margin-top: 0;
    padding: 0 1.5rem;
  `}
`

export const StyledButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 80%;
  margin-top: 4.5em;

  ${themeMedia.maxTablet`
    margin-top: auto;
    margin-bottom: 2em; 
    width: 100%;
  `}

  ${themeMedia.desktop`
    width: 60%;
  `}
`

export const StyledWidgetContainer = styled.div`
  height: ${({ formHeight }) => `${formHeight}px`};
  width: 100%;

  ${themeMedia.maxTablet`
    height: 100%;
  `}
`

export const StyledTitle = styled.p`
  font-weight: 400;
  margin: 0;

  ${themeMedia.desktop`
    font-size: 25px;
  `}
`
export const StyledContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1.8rem;
  flex:  1;

  p {
    text-align: center;
    width: 60%;
  }

  ${themeMedia.maxTablet`
    p {
      width: 90%;
    }
  `}
`

export const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;

  ${themeMedia.desktop`
    height: 500px;
  `}
`
